const value = {
    name: 'Name',
    description: 'Description',
    ordering: 'Ordering',
    orderingFormLabel: 'Ordering',
    active: 'Active',
    notActive: 'Not Active',
    showIfHaveValues: 'Show if there are values',
    showIfHaveNotValues: 'Show if there are no values',
    status: 'Status',
    category: 'Category',
    categoryName: 'Category - {{name}}',
    categoryUntitled: 'Untitled',
    categoryEntity: 'Category entity {{name}}',
  };

export default value;
